
import { CSSProperties } from "@mui/material/styles/createTypography"
import { IdentityClient } from "api-clients/IdentityClient"
import { PlansClient } from "api-clients/PlansClient"
import { LogoType, ProductInfoService } from "services/ProductInfoService"
import Container from "components/layout/Container"
import Grid from 'components/layout/grid/Grid'
import Item from 'components/layout/grid/Item'
import Computer, { IComputerProps } from "../../components/objects/computer/Computer"
import Title from "components/labels/Title"
import Subtitle from "components/labels/SubHeading"
import Page from "components/layout/Page"
import Section from "components/layout/Section"
import Button from "components/buttons/Button"
import Box from "components/layout/box/Box"
import Heading from "components/labels/Heading"
import Text from 'components/labels/Text';

import CardFeature from 'views/home/CardFeature'
import { ColorsUtil, MyTheme } from "MyTheme"
import { Avatar, Divider, FormControl, FormControlLabel, FormLabel, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Radio, RadioGroup, Stack, Step, StepButton, StepLabel, Stepper, Switch, useMediaQuery, Zoom } from "@mui/material"
import React, { useEffect, useRef, useState, VideoHTMLAttributes } from "react"
import useVisibility from "hooks/UseVisibility"
import Animation from "components/animations/Animation"
import SubHeading from "components/labels/SubHeading"
import TitleBlock from "components/layout/TitleBlock"
import Icon from "components/icons/Icon"
import { VideoMarker, VideoMarkersController } from "utils/VideoUtil"
import Modal from "components/modals/Dialog"
import Dialog from "components/modals/Dialog"
import ExpansionPanel from "components/transitions/expansionPanel/ExpansionPanel"
import Link from "components/buttons/Link"
import LoadingButton from "components/buttons/LoadingButton"
import { DialogUtil } from "utils/DialogUtil"
import { useSearchParams } from "react-router-dom"

const DeviceOptions = (props: any) => {
    const {isMacDevice, onToggleMacDeviceChanged, ...rest} = props;
    return(
        <FormControl variant="filled" size="small">
            <Stack spacing={1} alignItems='center' direction={'row'}>

      <FormLabel id="demo-row-radio-buttons-group-label"><Text bold>Device:</Text></FormLabel>
      
      <RadioGroup
        row
        value={isMacDevice ? 1 : 0}
        onChange={(e: any) => onToggleMacDeviceChanged(e.target.value === "1")}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        <FormControlLabel value={0} control={<Radio size="small" />} label="Windows" />
        <FormControlLabel value={1} control={<Radio size="small" />} label="Mac" />
      </RadioGroup>
      </Stack>

    </FormControl>
  );
}




export default DeviceOptions